import { render, staticRenderFns } from "./ProbableCandidate.vue?vue&type=template&id=5d5d1cd3&"
import script from "./ProbableCandidate.vue?vue&type=script&lang=js&"
export * from "./ProbableCandidate.vue?vue&type=script&lang=js&"
import style0 from "./ProbableCandidate.vue?vue&type=style&index=0&id=5d5d1cd3&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports